import { ComputationType, HierarchyLevel, HierarchyLevelV2, StorageLevelV2 } from '@twaice-fe/shared/models';

export function generateAlertSensorKey(
  name: string | undefined,
  levelBk: HierarchyLevel | HierarchyLevelV2 | StorageLevelV2 | undefined
) {
  return generateSensorKey(name, levelBk, ComputationType.Measurement);
}

export function generateSensorKey(
  name: string | undefined,
  levelBk: HierarchyLevel | HierarchyLevelV2 | StorageLevelV2 | undefined,
  computationType: string | undefined
) {
  if (name === undefined || levelBk === undefined || computationType === undefined) {
    return;
  }
  const twaiceSensor = computationType === ComputationType.Computation ? 'twaice_' : '';
  const cleanSensorName = name.toLowerCase().replace(/ /g, '_').replace(/\[|\]/g, '');
  return `${twaiceSensor}${levelBk}_${cleanSensorName}`;
}
